import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import Error from '../common/components/Error';

const ErrorContainer = props => {
	const { error } = props;

	// No error to display
	if (!error.errorText) {
		return <div />;
	}

	let buttonText = 'ok';
	let onClick = props.resetError;

	if (error.sessionExpired) {
		buttonText = 'se connecter';
		onClick = props.redirectToAuth;
	}

	return (
		<div>
			{error.errorText
				? <Error
						errorText={error.errorText}
						buttonText={buttonText}
						onClick={onClick}
					/>
				: null}
		</div>
	);
};

const mapStateToProps = state => {
	return {
		error: state.error
	};
};

const mapDispatchToProps = dispatch => {
	return {
		resetError: () => {
			dispatch({
				type: 'RESET_ERROR'
			});
		},
		redirectToAuth: () => {
			browserHistory.push('/');
			dispatch({
				type: 'RESET_ERROR'
			});
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorContainer);



// WEBPACK FOOTER //
// ./src/js/app/ErrorContainer.js